import { useEffect, useState } from "react";
import "./DCDialog.scss";
import { ReactSVG } from "react-svg";

interface DCDialogProps{
  open: boolean;
  header: string;
  children?: any;
  onclose: () => void;
  size: "lg" | "md" | "sm";
};

export const DCDialog = ({open, onclose, header, children, size}: DCDialogProps) => {
  //States
  const [openDialog, setOpen] = useState(false);


  const handleClose = () => {
    //execute toggle event
    const event = new CustomEvent("toggle", {});
    document.body.dispatchEvent(event);   
    onclose(); 
  }

  useEffect(() => {
    setOpen(open);
  }, [open]);

  //Render
  return (
    <div>
      <auro-dialog
      data-testid="dialog"
        id="entryDialog"
        open={openDialog ? "open" : undefined}
        modal
        {...(size === "lg" && { lg: true })}
        {...(size === "md" && { md: true })}
        {...(size === "sm" && { sm: true })}>
        <span slot="header" className="custom-header">
          {header}
          <div className="xDialog">
          <ReactSVG
          data-testid="closeButton"
            src="https://cdn.jsdelivr.net/npm/@alaskaairux/icons@latest/dist/icons/interface/x-lg.svg"
            onClick={() => { handleClose(); }}/>
          </div>
        </span>
        <span slot="content">{openDialog ? children : null}</span>
      </auro-dialog>
    </div>);
};